<template>
	<section class="content">
			<div class="divider"></div>
			<div class="info-content single-content">
				<div class="textbox-bounds  textbox-bounds-unbound-double">
					<div class="textbox textbox-right">
						<div class="textbox-tab-mark""></div>
						<div class="textbox-text">
							<div class="text-box-paragraph">
							<div class="auditionLogo">
								<img src="images/logo.png" alt="החצר" class="fillImg" >
								<div class="auditionLogoSubtitle">אנסמבל קולי</div>
							</div>
								<h3>ברוכים הבאים לחצר!</h3>
								<p>שלחנו למייל שלכם את ההנחיות לאודישן. חשוב מאוד לעבור עליהן ולהגיע מוכנים. ניתן לצפות בהנחיות
								<a href="https://yardbands.com/admin_uploads/%D7%94%D7%A0%D7%97%D7%99%D7%95%D7%AA%20%D7%9C%D7%9E%D7%95%D7%A2%D7%9E%D7%93%20%D7%9C%D7%90%D7%95%D7%93%D7%99%D7%A9%D7%9F%20%D7%9C%D7%90%D7%A0%D7%A1%D7%9E%D7%91%D7%9C.pdf" style="cursor:pointer;color:#FF632B;text-decoration: underline;">גם כאן.</a>
								</p>
								<h3>שאלות?</h3>
								<p>
								<b>אנחנו כאן בשבילכם.</b>
								</br>
								<b>במייל:</b>
								<a href="mailto:OFFICE@YARDBANDS.COM" style="cursor:pointer;color:#c7b7a5;text-decoration: underline;">office@yardbands.com</a>
								</br>
								<b>טלפון:</b>
								 054-7737094. אם לא עונים - השאירו הודעת ווצאפ ונחזור אליכם בהקדם.

								</p>
								<h3>נתראה בקרוב</h3>
							</div>
							<a href="http://yardbands.com"><label class="login-next-button">חזרה למסך הראשי</label></a>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
  import page from 'page'
  import VueScrollTo from 'vue-scrollto'
  export default {
    components: {
      MainLayout
    },
	created () {
		try{
			fbq('track', 'aud_comp_ens');
		}catch(err){}
	},
	destroyed(){
		window.removeEventListener('resize',this.windowResized);
	},
	data() {
		return {
			userName : '',
			instrument : '',
			auditionType : '',
			deal_id : '',
			hour : '',
			day : '',
			email : ''		
		}
	},
	methods: {
		scrollToHome() {
			window.location.href='http://dev.backyardbands.co.il'
		}
	}

  }
</script>



// WEBPACK FOOTER //
// PaymentEnsamble.vue?00f277ed